var resolve = require("./resolve");
var request = require("./request");
var Promise = require("bluebird");
var config = require("./config");

exports.GetApplicationAudits = function(id, funderId, viewName, pageNumber, pageSize) {
  var query = {
    funderId: funderId,
    viewName: viewName,
    pageNumber:pageNumber,
    pageSize:pageSize
  };
  return request.get(resolve(config.url(), "/applicationaudits/" + id),query).promise();
};
